import { axios } from "@v2/shared/api";
const notificationEndpoint = "notifications";
const notificationEndpointTypes = "notification-types";

export default {
  all(
    perPage = 5,
    page = 1,
    notificationType = null,
    companyId = null,
    exhibitionId = null
  ) {
    const data = {
      perPage,
      page
    };

    if (notificationType) data.notification_type = notificationType;
    if (companyId) data.company_id = companyId;
    if (exhibitionId) data.exhibition_id = exhibitionId;
    return axios.get(`${notificationEndpoint}`, { params: data });
  },

  update(notificationId) {
    return axios.put(`${notificationEndpoint}/${notificationId}`);
  },

  readAll() {
    return axios.post(`${notificationEndpoint}/read-all`);
  },

  getCategories() {
    return axios.get(`${notificationEndpointTypes}`);
  },

  getExhibitions() {
    return axios.get(`${notificationEndpoint}/exhibitions`);
  },

  getCompanies() {
    return axios.get(`${notificationEndpoint}/companies`);
  }
};
